import { DocumentoAllegato } from '../../../models/documento-allegato';
import { BenePignoratoImmobile } from '../../../models/immobili/bene-pignorato-immobile';
import { DatiCatastaliBase } from '../../../models/immobili/dati-catastali-base';
import { DatiCatastaliTerreniExtra } from '../../../models/immobili/dati-catastali-terreni-extra';
import { DatiCatastaliUrbanoExtra } from '../../../models/immobili/dati-catastali-urbano-extra';
import { DatiDenuncia } from '../../../models/immobili/dati-denuncia';
import { IstanzaAssegnazione } from '../../../models/immobili/istanza-assegnazione';
import { IstanzaVendita } from '../../../models/immobili/istanza-vendita';
import { Ubicazione } from '../../../models/immobili/ubicazione';


export class BeniImmobiliAdapter {
  documenti: DocumentoAllegato[];
  beneImmobile: BenePignoratoImmobile = new BenePignoratoImmobile();
  constructor(beneImmobile: BenePignoratoImmobile) {
    if (beneImmobile.id) {
      this.beneImmobile.id = beneImmobile.id;
    }
    this.beneImmobile.tipoCatasto = beneImmobile.tipoCatasto ? JSON.parse(JSON.stringify(beneImmobile.tipoCatasto)) : null;
    this.beneImmobile.descrizione = beneImmobile.descrizione;
    this.beneImmobile.ubicazione = beneImmobile.ubicazione ? JSON.parse(JSON.stringify(beneImmobile.ubicazione)) : new Ubicazione();
    this.beneImmobile.valore = beneImmobile.valore;
    this.beneImmobile.ipoteca = beneImmobile.ipoteca ? beneImmobile.ipoteca : false;
    this.beneImmobile.nudaProprieta = beneImmobile.nudaProprieta ? beneImmobile.nudaProprieta : false;
    this.beneImmobile.datiCatastaliBase = beneImmobile.datiCatastaliBase ? JSON.parse(JSON.stringify(beneImmobile.datiCatastaliBase)) : new DatiCatastaliBase();
    this.beneImmobile.datiCatastaliUrbanoExtra = beneImmobile.datiCatastaliUrbanoExtra ? JSON.parse(JSON.stringify(beneImmobile.datiCatastaliUrbanoExtra)) : new DatiCatastaliUrbanoExtra();
    this.beneImmobile.datiCatastaliTerreniExtra = beneImmobile.datiCatastaliTerreniExtra ? JSON.parse(JSON.stringify(beneImmobile.datiCatastaliTerreniExtra)) : new DatiCatastaliTerreniExtra();
    this.beneImmobile.datiDenuncia = beneImmobile.datiDenuncia ? JSON.parse(JSON.stringify(beneImmobile.datiDenuncia)) : new DatiDenuncia();
    this.beneImmobile.istanzaVendita = new IstanzaVendita();
    if (beneImmobile.istanzaVendita) {
      if (beneImmobile.istanzaVendita.id) {
        this.beneImmobile.istanzaVendita.id = beneImmobile.istanzaVendita.id;
      }
      this.beneImmobile.istanzaVendita.dataIstanza = beneImmobile.istanzaVendita.dataIstanza;
      this.beneImmobile.istanzaVendita.acquirente = beneImmobile.istanzaVendita.acquirente;
      this.beneImmobile.istanzaVendita.ricavato = beneImmobile.istanzaVendita.ricavato;
      if (this.beneImmobile.istanzaVendita.ricavato) {
        this.beneImmobile.istanzaVendita.ricavato = this.beneImmobile.istanzaVendita.ricavato.toString().trim().replace('.', ',');
      }
      if (beneImmobile.istanzaVendita.vendita) {
        this.beneImmobile.istanzaVendita.vendita = beneImmobile.istanzaVendita.vendita;
      } else {
        this.beneImmobile.istanzaVendita.vendita = false;
      }

    } else {
      this.beneImmobile.istanzaVendita.vendita = false;
    }
    this.beneImmobile.istanzaAssegnazione =  new IstanzaAssegnazione();
    if (beneImmobile.istanzaAssegnazione) {
      if (beneImmobile.istanzaAssegnazione.id) {
        this.beneImmobile.istanzaAssegnazione.id = beneImmobile.istanzaAssegnazione.id;
      }
      this.beneImmobile.istanzaAssegnazione.dataIstanza =  beneImmobile.istanzaAssegnazione.dataIstanza;
      if (beneImmobile.istanzaAssegnazione.assegnato) {
        this.beneImmobile.istanzaAssegnazione.assegnato = beneImmobile.istanzaAssegnazione.assegnato;
      } else {
        this.beneImmobile.istanzaAssegnazione.assegnato = false;
      }
    } else {
      this.beneImmobile.istanzaAssegnazione.assegnato = false;
    }
    this.beneImmobile.note = beneImmobile.note;
  }
}
